import { useCalculatorContext } from './CalculatorContext';
import classNames from 'classnames';
import Link from 'components/atoms/Link/Link';
import styles from './Calculator.module.scss';

export const LoanInfoButton = ({ className }: { className?: string }) => {
  const {
    showModal,
    content: { openLoanInformationModal },
    setShowModal,
    hasModal,
  } = useCalculatorContext();

  const legalContentHandler = () => setShowModal(true);

  if (!hasModal) return <></>;

  return (
    <div className={classNames(styles.informationLoanContainer, className)}>
      <Link
        className={styles.informationLoan}
        dataTest="legalTermsLink"
        disabled={showModal}
        onClick={legalContentHandler}
      >
        {openLoanInformationModal}
      </Link>
    </div>
  );
};
